import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { truncateText } from '../../helpers/utils';
import Table from '../Table/Table';
import { tablesHeaders } from '../../consts/tablesConf';
import { ADS } from '../../consts/navigation';
import AdsThumbnail from '../Table/AdsThumbnail/AdsThumbnail';
import { FETCH_ADS } from '../../redux/Ads';
import AdsTableButtonsCell from './AdsTableButtonsCell';
import { SET_VEHICLE_TYPE } from '../../redux/VehicleTypeReducer';
import { vehicleTypes } from '../../consts/vehicleTypes';

const AdsContainer = ({ fetchAds, totalCount, totalPages, ads, isMobile, history, setVehicleType, vehicleType, }) => {
  useEffect(() => {
    // for now ads feature is only supported for motorbikes
    if (vehicleType !== vehicleTypes.Motorbike) {
      setVehicleType(vehicleTypes.Motorbike)
    }
  }, [])
  const renderRow = (item) => {
    const formattedModel = truncateText(get(item, 'model'), 17, 'right');
    const mobileCells = [
      <td key="mobile-cells" className="cell-mobile-wrapper">
        <div>
          <span>{get(item, 'brand')} {formattedModel}</span>
        </div>
        <div>
          <span>{get(item, 'year')}, {get(item, 'price')} &euro;</span>
        </div>
      </td>
    ];
    const desktopCells = [
      <td key="brand">{get(item, 'brand')}</td>,
      <td key="model" className="cell-model">
        {formattedModel}
      </td>,
      <td key="year">{get(item, 'year')}</td>,
      <td key="total_mileage">{get(item, 'total_mileage')}</td>,
      <td key="price">{get(item, 'price')}&euro;</td>,
      <AdsTableButtonsCell adId={item.id} key="buttons" />
    ];

    return [
      <AdsThumbnail
        key="score"
        photo={get(item, 'photo')}
        model={get(item, 'model')}
      />
    ].concat(isMobile ? mobileCells : desktopCells);
  };

  return (
    <div>
      <Table
        whichFolder={ADS}
        tableHeaders={tablesHeaders[ADS]}
        fetchOffers={fetchAds}
        totalCount={totalCount}
        totalPages={totalPages}
        renderRow={renderRow}
        onRowClick={(id) => history.push(`/dashboard/ads/${id}/promote/`)}
        items={ads}
      />
    </div>
  );
};


AdsContainer.propTypes = {
  fetchAds: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  setVehicleType: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  isMobile: PropTypes.bool,
  ads: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalPages: PropTypes.number,
  totalCount: PropTypes.number,
};

AdsContainer.defaultProps = {
  myBets: [],
  isMobile: true,
  totalPages: 1,
  totalCount: 0,
};


const mapStateToProps = (state) => {
  return {
    ads: get(state, [ADS, 'data']),
    totalCount: get(state, [ADS, 'total_count']),
    totalPages: get(state, [ADS, 'total_pages']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAds: () => dispatch(FETCH_ADS()),
    setVehicleType: (vehicleType) => dispatch(SET_VEHICLE_TYPE(vehicleType)),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AdsContainer);
